import React from "react";
import ReactDOM from 'react-dom/client';
import { PDFDocument } from 'pdf-lib';
import html2canvas from 'html2canvas';
import BelaPotvrdaStrana from "./belaPotvrdaStrana";

const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Bela potvrda - Štampa</title>
          <style>
            .paragraph{margin: 50px 0 50px 0;font-size:11pt;line-height:1.35;text-align:justify}
            .title {text-align:center}
          *{box-sizing:border-box}
      html,body{margin:0;padding:0;font-family:Arial, sans-serif;font-size:11pt;color:#000}
      @page{size:A4 portrait;margin:0}
      #print-root{page:auto;position:relative;min-height:100vh}
      .print-page{width:210mm;position:relative;display:block;page-break-inside:avoid;padding:20mm 30mm}
      .print-page:not(:last-child){page-break-after:always}
      .cemt-page { padding: 18mm 20mm 22mm 22mm; font-size: 11pt; color:#000; }
    .rs-header { line-height: 1; }
    .rs-header { font-size: 18px; }
    .top-right { position:absolute; right:20mm; top:18mm; width:70mm; }
    .top-right .row { display:flex; align-items:center; gap:6mm; margin-bottom:6mm; }
    .top-right .row .line { flex:1; border-bottom:1px solid #000; height:16px; }
    .applicant { text-align:center; margin-top:10mm; }
    .applicant .name { font-weight:700; font-size:12pt; }
    .applicant .addr { margin-top:2mm; }
    .applicant .hint { font-size:9pt; color:#444; margin-top:2mm; }
    .name {border-bottom: 1px solid #000;}
    .addr {border-bottom: 1px solid #000;}
    .lead { margin: 8mm 0; line-height: 1.35; text-align: justify; }
    .cemt-title { letter-spacing: 3px; font-size: 20pt; margin: 10mm 0; text-align:center; }
    .u-ime { margin-bottom: 8mm; }
    .u-ime ol { margin: 3mm 0 0 6mm; }
    .u-ime li { margin: 2mm 0; }
    .section-title { margin: 5mm 30mm 2mm 30mm; font-weight:700; }
    .vozilo-grid {
      display:grid;
      grid-template-columns: 55mm 1fr;
      column-gap: 6mm;
      row-gap: 3.5mm;
      align-items:center;
      margin: 0 30mm 3mm 30mm;
    }
    .vozilo-grid .lbl { white-space: nowrap; }
    .vozilo-grid .val.underline {
      border-bottom: 1px solid #000;
      min-height: 14pt;
      display:flex; align-items:flex-end;
      padding-bottom: 2px;
    }
    .check-list { margin: 4mm 0 12mm 0; padding-left: 0; list-style: none; }
    .check-list li { margin: 1.5mm 0; }
    .footer-sign { display:flex; align-items:flex-end; justify-content:flex-end; margin-top: 12mm; position: relative; }
    .footer-sign .mp { position:absolute; left:0%; bottom:15px; border-top: 1px solid #000; font-size: 10px;}
    .footer-sign .potpisnik { width: 65mm; text-align:center; }
    .footer-sign .potpisnik .line { border-top:1px solid #000; margin-bottom: 3mm; }
    .footer-sign .potpisnik .hint { font-size:9pt; color:#444;}
    .footer-sign .potpisnik .name { margin-top: 2mm; font-weight:700; }
    .potpisnik p.hint {font-size: 18px;margin-bottom: 20px;}
    .potpisnik div:nth-child(4) {margin-bottom: 30px;}
      @media print{
      *{-webkit-print-color-adjust:exact;print-color-adjust:exact}
      }
                </style>
              </head>
              <body>
                <div id="print-content"></div>
              </body>
            </html>
    `;

const toRelativePath = (path) => {
    if (!path) return null;
    return path.replace(/\\/g, '/').replace(/^C:\/Dokumenta\//, '');
};

const fetchPdfBytes = async (path, backendUrl, token) => {
    const url = `${backendUrl}/files/${encodeURI(toRelativePath(path))}`;
    const resp = await fetch(url, { headers: { Authorization: 'Bearer ' + token } });
    if (!resp.ok) throw new Error(`HTTP ${resp.status}: ${url}`);
    return resp.arrayBuffer();
};

const addPdfPagesToDoc = async (mergedPdf, bytes) => {
    const src = await PDFDocument.load(bytes, { ignoreEncryption: true });
    const pages = await mergedPdf.copyPages(src, src.getPageIndices());
    pages.forEach(p => mergedPdf.addPage(p));
};

const addImagePageToDoc = async (mergedPdf, bytes, mimeType) => {
    const page = mergedPdf.addPage([595.28, 841.89]);
    const img = mimeType === 'image/png'
        ? await mergedPdf.embedPng(bytes)
        : await mergedPdf.embedJpg(bytes);
    const { width, height } = page.getSize();
    page.drawImage(img, { x: 0, y: 0, width, height });
};

export default async function handlePrintCEMT(podaci, backendUrl, token) {
    // --- Strana 1: original popup CSS → html2canvas → PDF stranica ---
    const printWindow = window.open('', '_blank', 'width=1000,height=700');
    printWindow.document.open();
    printWindow.document.write(printContent);

    const styleEl = printWindow.document.createElement("style");
    styleEl.textContent = `
  @page { size: A4 portrait; margin: 0; }
  html, body { margin: 0; padding: 0; }
  .print-page {
    position: relative;
    display: block;
    width: 297mm;
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .print-page.first { padding: 0.75in 1.3in; }
`;
    printWindow.document.head.appendChild(styleEl);
    printWindow.document.close();

    const printContainer = printWindow.document.getElementById('print-content');
    const { createRoot } = ReactDOM;
    const root = createRoot(printContainer);
    root.render(<BelaPotvrdaStrana podaci={podaci} />);

    // Čekamo da se React i fontovi renderuju
    await new Promise(r => setTimeout(r, 800));

    // html2canvas hvata popup (same-origin)
    const canvas = await html2canvas(printContainer, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false,
        allowTaint: true,
    });

    printWindow.close();

    // --- Kreiraj merged PDF ---
    const mergedPdf = await PDFDocument.create();

    // Strana 1: canvas → skaliramo proporcionalno na A4
    const imgDataUrl = canvas.toDataURL('image/png');
    const pngResp = await fetch(imgDataUrl);
    const pngBytes = await pngResp.arrayBuffer();
    const pngImage = await mergedPdf.embedPng(pngBytes);

    const A4_W = 595.28, A4_H = 841.89;
    const s = Math.min(A4_W / canvas.width, A4_H / canvas.height);
    const drawW = canvas.width * s;
    const drawH = canvas.height * s;
    const page1 = mergedPdf.addPage([A4_W, A4_H]);
    page1.drawImage(pngImage, { x: (A4_W - drawW) / 2, y: A4_H - drawH, width: drawW, height: drawH });

    // Strana 2: CemtBelaPotvrdaDokument (iz VazniDatumi)
    if (podaci.cemtBelaPotvrdaDokument) {
        try {
            const bytes = await fetchPdfBytes(podaci.cemtBelaPotvrdaDokument, backendUrl, token);
            const ext = podaci.cemtBelaPotvrdaDokument.toLowerCase();
            if (ext.endsWith('.pdf')) {
                await addPdfPagesToDoc(mergedPdf, bytes);
            } else {
                await addImagePageToDoc(mergedPdf, bytes, ext.endsWith('.png') ? 'image/png' : 'image/jpeg');
            }
        } catch (e) {
            console.warn('CemtBelaPotvrdaDokument nije učitan:', e.message);
        }
    }

    // Strane 3+: LicenceDokument fajlovi (| razgraničeni, iz PrvaRegistracija)
    if (podaci.licenceDokument) {
        const paths = podaci.licenceDokument.split('|').filter(p => p.trim());
        for (const path of paths) {
            try {
                const bytes = await fetchPdfBytes(path.trim(), backendUrl, token);
                const ext = path.trim().toLowerCase();
                if (ext.endsWith('.pdf')) {
                    await addPdfPagesToDoc(mergedPdf, bytes);
                } else {
                    await addImagePageToDoc(mergedPdf, bytes, ext.endsWith('.png') ? 'image/png' : 'image/jpeg');
                }
            } catch (e) {
                console.warn('LicenceDokument nije učitan:', path, e.message);
            }
        }
    }

    // --- Download ---
    const pdfBytes = await mergedPdf.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `ZAHTEV_BelaPotvrda_${podaci.registracija || Date.now()}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
